import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

import request from '../../../../../utils/request';
import { sortedObjects } from '../../../../../utils/utils';
import Label from './common/label';

const Channel = ({ fieldData, setFieldData, formErrors }) => {
  const [channelsList, setChannelsList] = useState([]);
  const fieldError = 'channels' in formErrors;

  const styles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #e3e3e3',
      fontWeight: 500,
      fontSize: '14px',
      color: '#555',
      marginLeft: '10px',
      backgroundColor: 'white'
    }),
    control: () => ({
      display: 'flex',
      borderRadius: '3px',
      border: '1px solid #333',
      height: '51px',
      fontSize: '14px'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color,
      fontSize: state.selectProps.myFontSize
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: '#2B8000',
      paddingRight: '4px',
      paddingTop: '6px'
    }),
    // A z-index of 1 gets trapped behind later siblings that create their own stacking
    // context - render the menu in a body-level portal so it always paints on top.
    menuPortal: provided => ({ ...provided, zIndex: 9999 })
  };

  const getChannelValue = () => {
    if (channelsList) {
      const selectedChannel = channelsList.find(
        channel => channel.value === fieldData.channels[0]
      );
      return [selectedChannel];
    }
    return null;
  };

  useEffect(() => {
    request.get('/channels').then(({ data: { channels } }) => {
      const updatedChannelList = sortedObjects(channels, 'description').map(
        ({ name, description }) => {
          return { value: name, label: description };
        }
      );
      setChannelsList(updatedChannelList);
    });

    return () => {
      setFieldData(previousValue => ({ ...previousValue, channels: [] }));
    };
  }, []);

  return (
    <div className={fieldError ? 'field-error' : ''}>
      <Label labelName="Channel *" />
      {fieldError && (
        <div className="error-notification">
          <p>{formErrors.channels.message}</p>
        </div>
      )}
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-2rem' }}
        className="frg-select-container color-light input-container"
      >
        <Select
          name="channel"
          options={channelsList}
          styles={styles}
          value={getChannelValue()}
          onChange={selectedValue => {
            setFieldData(previousValue => ({
              ...previousValue,
              channels: [selectedValue.value]
            }));
          }}
          menuPortalTarget={document.body}
        />
      </div>
    </div>
  );
};

Channel.propTypes = {
  formErrors: PropTypes.shape({
    channels: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Channel;
